export default __webpack_public_path__ + "static/img-2-21808c5098ccfea45ceb26229c3eb9c6.png";